import { columnsStyles } from "@insite/content-library/Widgets/ProductList/ProductListColumns";
import { css } from "styled-components";
// EC-617 : Fixing css issues on PLP & PDP
columnsStyles.leftColumnGridItem = {
    width: [12, 12, 3, 3, 3],
    css: css`
        div [data-test-selector="cart_pickUpLocation"] {
            p[data-test-selector="cart_warehouseName"] {
                font-size: 12px;
            }
            address[data-test-selector="addressInfoDisplay"] {
                p {
                    font-size: 12px;
                }
            }
        }
    `
}